export default __webpack_public_path__ + "static/media/EngineeringTunnels_08.ae635cb6.png";